import { endGameSession } from '@sorrem-client/game/game-session-store';
import { SettingsPopover } from '@sorrem-client/ui/features/SettingsPopover';
import { useGameplay } from '@sorrem-client/ui/features/PlayPage/gameplay-context';
import { useAppNavigate, useDeveloperAccess, useGameSelector } from '@sorrem-client/ui/hooks';
import { logout } from '@sorrem-client/ui/shared/auth-session';
import { useCallback } from 'react';
import { DeveloperSettingsSection } from '../DeveloperSettingsSection';
import { EngineTelemetryPanel } from '../EngineTelemetryPanel';
import { EntityInfoPanel } from '../EntityInfoPanel';
import styles from './GameOverlayAreaHead.module.scss';

/** The settings gear, and any debug panels, heading the run HUD's top-right area. */
export function GameOverlayAreaHead(): JSX.Element {
    const navigate = useAppNavigate();
    const { bridge, debugControls } = useGameplay();
    const { isDeveloper } = useDeveloperAccess();
    const debugOverlaySettings = useGameSelector(bridge, (state) => state.debugOverlaySettings);
    const selectedEntityInfo = useGameSelector(bridge, (state) => state.selectedEntityInfo);

    const handleLogout = useCallback((): void => {
        void (async (): Promise<void> => {
            await endGameSession();
            await logout();
            navigate('/login');
        })();
    }, [navigate]);

    return (
        <>
            <SettingsPopover placement="bottom" onLogout={handleLogout} className={styles.settingsButton}>
                {isDeveloper && (
                    <DeveloperSettingsSection
                        settings={debugOverlaySettings}
                        onChange={(nextSettings) => bridge.setDebugOverlaySettings(nextSettings)}
                        debugControls={debugControls}
                    />
                )}
            </SettingsPopover>
            <div className={styles.debugSlot}>
                {debugOverlaySettings.telemetryEnabled && <EngineTelemetryPanel bridge={bridge} />}
                {debugOverlaySettings.entityInfoEnabled && <EntityInfoPanel entityInfo={selectedEntityInfo} />}
            </div>
        </>
    );
}
